import { render, staticRenderFns } from "./Estado_pagos.vue?vue&type=template&id=28e9016e"
import script from "./Estado_pagos.vue?vue&type=script&lang=js"
export * from "./Estado_pagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports